import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposDocumentoIdentificacionConstant } from 'constants/index'

const TipoDocumentoFormGroup = ({ iError, iTouched }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO DOC' htmlFor='select-tipoDocumento' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        <Field name='tipoDocumento'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled
              isInvalid={iTouched && iError}
              id='select-tipoDocumento'
            >
              <option value={TiposDocumentoIdentificacionConstant.DNI}>
                {
                  TiposDocumentoIdentificacionConstant.__dictionary[
                    TiposDocumentoIdentificacionConstant.DNI
                  ].nombreCorto
                }
              </option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
